import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

export const generalInfraImageUrl: string =
  'https://zippmat.com/assets/img/material-images/general_infrastructure_construction.jpg';

@Injectable({
  providedIn: 'root',
})
export class CustomerOrderService {
  http = inject(HttpClient);

  public getApiCustomerInfo(): Observable<any> {
    return this.http.get('/api/v1/customer-user/data/customer-info');
  }

  public getApiCustomerInfoHighlightStatement(): Observable<any> {
    return this.http.get('/api/v1/customer-user/data/customer-info/highlight-statement');
  }

  public getApiCustomerAgingReport(): Observable<any> {
    return this.http.get('/api/v1/customer-user/data/aging-report');
  }

  public getApiCustomerOutstandingInvoices(pageNumber: number = 1, pageSize: number = 20): Observable<any> {
    let params = new HttpParams();

    if (pageNumber) {
      params = params.append('pageNumber', pageNumber);
    }
    if (pageSize) {
      params = params.append('pageSize', pageSize);
    }

    return this.http.get('/api/v1/customer-user/data/customer-outstanding-invoices', { params: params });
  }

  public getApiCompletedOrders(appliedFilters: { [key: string]: string }): Observable<any> {
    let params = new HttpParams();

    for (const key in appliedFilters) {
      params = params.append(key, appliedFilters[key]);
    }

    return this.http.get('/api/v1/customer-user/data/orders/completed', {
      params: params,
    });
  }

  public getApiOngoingOrders(appliedFilters: { [key: string]: string }): Observable<any> {
    let params = new HttpParams();

    for (const key in appliedFilters) {
      params = params.append(key, appliedFilters[key]);
    }

    return this.http.get('/api/v1/customer-user/data/orders/ongoing', {
      params: params,
    });
  }

  public getApiQuotedOrders(appliedFilters: { [key: string]: string }): Observable<any> {
    let params = new HttpParams();

    for (const key in appliedFilters) {
      params = params.append(key, appliedFilters[key]);
    }

    return this.http.get('/api/v1/customer-user/data/orders/quoted', {
      params: params,
    });
  }

  public getApiOpenOrders(appliedFilters: { [key: string]: string }): Observable<any> {
    let params = new HttpParams();

    for (const key in appliedFilters) {
      params = params.append(key, appliedFilters[key]);
    }

    return this.http.get('/api/v1/customer-user/data/orders/open', {
      params: params,
    });
  }

  public getApiCustomerOrder(customerOrderId: string): Observable<any> {
    return this.http.get(`/api/v1/customer-user/data/order/${customerOrderId}`);
  }

  public getApiCustomerOrderInvoices(
    customerOrderId: string,
    pageNumber: number = 1,
    pageSize: number = 20
  ): Observable<any> {
    let params = new HttpParams();

    if (pageNumber) {
      params = params.append('pageNumber', pageNumber);
    }
    if (pageSize) {
      params = params.append('pageSize', pageSize);
    }

    return this.http.get(`/api/v1/customer-user/data/order/${customerOrderId}/customer-invoices`, { params: params });
  }

  public searchAutocomplete(
    entityType: string,
    search: string,
    parentEntityId: string | null = null
  ): Observable<any> {
    let params = new HttpParams();

    params = params.append('entityType', entityType);
    params = params.append('search', search);

    if (parentEntityId !== null) {
      params = params.append('parentEntityId', parentEntityId);
    }

    return this.http.get('/api/v1/customer-user/autocomplete', {
      params: params,
    });
  }

  public getZohoCustomerStatementDownload(startDate: string = '', endDate: string = ''): Observable<Blob> {
    let params = new HttpParams();
    if (startDate) params = params.set('start_date', startDate);
    if (endDate) params = params.set('end_date', endDate);

    return this.http.get<Blob>(`/api/v1/zoho/customer-statement/pdf/download`, {
      params,
      responseType: 'blob' as 'json',
    });
  }
}
